module.exports = __webpack_public_path__ + "media/images/hero-allcare-banner-1920-513643cba068b7c21efb9f454125c0d5.jpg";